import { SuccessNotifications } from 'components/Notification';
import { WrapStrong } from 'components/WrapStrong';
import React, { FC, ReactNode } from 'react';
import { translationKeys, useTranslation } from 'services/localization';
import { ActionNotificationMessageProps } from '../../types';

const SuccessUpdateConsent: FC<ActionNotificationMessageProps> = ({ data }) => {
  const { translate } = useTranslation();

  let content: ReactNode = (
    <>
      <p>{translate(translationKeys.NOTIFICATION_UPDATE_SUCCESS_MESSAGE_DESCRIPTION)}</p>
      <small>
        <WrapStrong value={translate(translationKeys.NOTIFICATION_NOTE_MESSAGE)} start={0} end={2} />
      </small>
    </>
  );
  if (data === 'DOUBLE_OPT_IN') {
    content = <p>{translate(translationKeys.NOTIFICATION_UPDATE_CONSENT_DOUBLE_OPT_IN_MESSAGE)}</p>;
  }

  return (
    <SuccessNotifications title={translate(translationKeys.NOTIFICATION_UPDATE_SUCCESS_MESSAGE_TITLE)}>
      {content}
    </SuccessNotifications>
  );
};

export default SuccessUpdateConsent;
